import { Button, Card, CardFooter } from "@rumbledirect/ui";
import type { Dispatch, SetStateAction } from "react";
import type { SmsSent } from "@rumble-it/common-lib/types/models/SmsSent.interface";
import { Modal } from "@/components/v2";

interface ModalSmsCorrespondenceProps {
  smsDetails: SmsSent | null | undefined;
  title: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
}

export const ModalSmsCorrespondence = ({
  smsDetails,
  title,
  isOpen,
  setIsOpen,
  loading = false,
}: ModalSmsCorrespondenceProps) => {
  const { sender, recipient, message } = smsDetails || {};

  return (
    <Modal
      loading={loading}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      width="80%"
    >
      <Card title={title}>
        <div className="flex flex-col gap-4 w-full">
          <div className="bg-white rounded flex flex-col gap-4">
            {sender ? (
              <span>
                <strong>Afzender:</strong> {sender}
              </span>
            ) : null}

            <span>
              <strong>Ontvanger:</strong> {recipient}
            </span>

            <span>
              <strong>Bericht:</strong>
            </span>

            <div className="border border-gray-200 px-4 py-2 mb-4">
              <code>{message}</code>
            </div>

            <span>
              <strong>Lengte van het bericht:</strong> {message?.length ?? 0}{" "}
              karakters
              {message && message.length > 160
                ? ` (dit bericht bestaat uit ${Math.ceil(message.length / 160)} SMS-berichten van 160 karakters)`
                : ""}
            </span>
          </div>
        </div>

        <CardFooter>
          <Button onClick={() => setIsOpen(false)}>Sluiten</Button>
        </CardFooter>
      </Card>
    </Modal>
  );
};

export default ModalSmsCorrespondence;
